module.exports = "<div class=\"text-center\"><p><small class=\"text-muted hide\">Powered by {{$ctrl.SETTINGS.SITE_NAME}}</small></p></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.pug
// module id = 164
// module chunks = 0